import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 18",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M9.04 2.038A6.922 6.922 0 003.136 12.58l.209.34-1.303 3.038 3.039-1.303.34.209a6.922 6.922 0 0010.54-5.902 6.922 6.922 0 00-6.923-6.923zM.578 8.961a8.46 8.46 0 114.387 7.417l-2.317.993c-1.276.547-2.567-.744-2.02-2.02l.993-2.317A8.434 8.434 0 01.579 8.96zm7.732-2.97a.77.77 0 111.539 0 .77.77 0 01-1.54 0zm-.012 6.585V8.42c0-.417.344-.755.769-.755.424 0 .769.338.769.755v4.156a.763.763 0 01-.77.755.763.763 0 01-.768-.755z",
		fillRule: "evenodd"
	})
});
export default SvgInfo;
